import React, { FC } from 'react';
import { NumericFormat } from 'react-number-format';
import { FilledInputProps, TextField } from '@mui/material';
import _ from 'lodash';

interface IntegerFieldProps {
  label: string;
  fieldName: string;
  formik: any;
  placeholder?: string;
  inputProps?: Partial<FilledInputProps>;
  disabled?: boolean;
  size?: 'small' | 'medium';
  hideHelperText?: boolean;
  margin?: 'dense' | 'normal' | 'none';
}

export const IntegerField: FC<IntegerFieldProps> = ({
  label,
  fieldName,
  formik,
  placeholder,
  disabled,
  size,
  hideHelperText,
  margin = 'normal',
}) => {
  const value = _.get(formik.values, fieldName);
  const errors = _.get(formik.errors, fieldName);
  const touched = _.get(formik.touched, fieldName);

  return (
    <NumericFormat
      customInput={TextField}
      label={label}
      type="text"
      variant="outlined"
      fullWidth
      decimalScale={0}
      placeholder={placeholder}
      value={value}
      margin={margin}
      onValueChange={(values) => {
        formik.setFieldValue(fieldName, values.floatValue);
      }}
      error={touched && Boolean(errors)}
      helperText={!hideHelperText ? (touched && errors) ?? ' ' : ''}
      disabled={disabled}
      valueIsNumericString={true}
      thousandSeparator={false}
      size={size}
      inputProps={{ 'data-cy': fieldName + '-field' }}
    />
  );
};
